export default {
    showPCForm () {
        let pcFormHtml = '<div class="container-pc form">\n' +
            '    <div class="dialog">\n' +
            '        <div class="dialog-content-wrapper">\n' +
            '            <div class="dialog-title">\n' +
            '                <span>申请使用</span>\n' +
            '                <span class="close"></span>\n' +
            '            </div>\n' +
            '            <div>\n' +
            '                <div>\n' +
            '                    <label><span>*</span>机构/团队名称：</label>\n' +
            '                    <input class="orgNameInput" placeholder="请输入团队或机构名称"/>\n' +
            '                </div>\n' +
            '                <div>\n' +
            '                    <label><span>*</span>申请人姓名：</label>\n' +
            '                    <input class="nameInput" placeholder="请输入申请人姓名"/>\n' +
            '                </div>\n' +
            '                <div>\n' +
            '                    <label><span>*</span>申请人职务：</label>\n' +
            '                    <input class="dutyInput" placeholder="请输入申请人职务"/>\n' +
            '                </div>\n' +
            '                <div>\n' +
            '                    <label><span>*</span>申请人手机号：</label>\n' +
            '                    <input class="phoneInput" placeholder="请输入申请人手机号"/>\n' +
            '                </div>\n' +
            '                <div>\n' +
            '                    <label>企业邮箱：</label>\n' +
            '                    <input class="emailInput" placeholder="请输入企业邮箱"/>\n' +
            '                </div>\n' +
            '                <div>\n' +
            '                    <label>使用场景：</label>\n' +
            '                    <textarea class="sceneDescInput" placeholder="请输入您的使用场景"></textarea>\n' +
            '               <div>\n' +
            '                    <label>获知渠道：</label>\n' +
            '                    <input class="channelInput" placeholder="您是怎么知道我们的"/>\n' +
            '                </div>\n' +
            '                    <label></label>\n' +
            '                    <p>提交后，运营人员将在1-2个工作日内与您联系</p>\n' +
            '                </div>\n' +
            '\n' +
            '                <div>\n' +
            '                    <label></label>\n' +
            // '                    <button class="cancel">取消</button>\n' +
            '                    <button class="summit summitBtn">提交</button>\n' +
            '                </div>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '\n' +
            '    </div>\n' +
            '</div>'

        $('body').append(pcFormHtml)
        $('.dialog-title .close,.cancel').click(function () {
            $('.container-mobile,.container-pc').remove()
            $('.applyBtn-web').removeClass('disable')
            $('.applyBtn button').removeClass('disable')
        })
    },
    removePCForm () {
        $('.container-pc.form').remove()
    },
    showPCFinished () {
        let pcFinishedHtml = '<div class="container-pc finished">\n' +
            '    <div class="dialog">\n' +
            '        <div class="dialog-content-wrapper">\n' +
            '            <div class="dialog-title">\n' +
            '                <span>申请使用</span>\n' +
            '                <span class="close"></span>\n' +
            '            </div>\n' +
            '            <div class="dialog-content-finish">\n' +
            '                <div class="holder"></div>\n' +
            '                <div class="dialog-finish-web"></div>\n' +
            '                <h2>已提交申请</h2>\n' +
            '                <div class="info">将会有运营人员在1-2个工作日内联系您，为您开通使用</div>\n' +
            '                <button class="summit">知道了</button>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '\n' +
            '    </div>\n' +
            '</div>'
        $('body').append(pcFinishedHtml)
        $('.dialog-content-finish .summit').click(function () {
            // $('.container-mobile.finished').css({ "display": 'none' })
            $('.container-pc.finished').remove()
        })
        $('.dialog-title .close,.cancel').click(function () {
            $('.container-mobile,.container-pc').remove()
            $('.applyBtn-web').removeClass('disable')
            $('.applyBtn button').removeClass('disable')
        })
    },
    removePCFinished () {
        $('.container-pc.finished').remove()
    },
    showMobileForm () {
        let mFormHtml = '<div class="container-mobile form">\n' +
            '    <div class="dialog">\n' +
            '        <div class="dialog-content-wrapper">\n' +
            '            <div class="dialog-title">\n' +
            '                <div class="close"></div>\n' +
            '                <span class="title">申请使用</span>\n' +
            '            </div>\n' +
            '            <div>\n' +
            '                <div>\n' +
            '                    <label><span>*</span></label>\n' +
            '                    <input class="orgNameInput" placeholder="机构/团队名称"/>\n' +
            '                </div>\n' +
            '                <div class="input-double-column">\n' +
            '                    <div>\n' +
            '                        <label><span>*</span></label>\n' +
            '                        <input class="nameInput" placeholder="申请人姓名"/>\n' +
            '                    </div>\n' +
            '                    <div>\n' +
            '                        <label><span>*</span></label>\n' +
            '                        <input class="dutyInput" placeholder="申请人职务"/>\n' +
            '                    </div>\n' +
            '                </div>\n' +
            '                <div>\n' +
            '                    <label><span>*</span></label>\n' +
            '                    <input class="phoneInput" placeholder="申请人手机号"/>\n' +
            '                </div>\n' +
            '                <div>\n' +
            '                    <label></label>\n' +
            '                    <input class="emailInput" placeholder="企业邮箱"/>\n' +
            '                </div>\n' +
            '                <div>\n' +
            '                    <label></label>\n' +
            '                    <textarea class="sceneDescInput" placeholder="您的使用场景"></textarea>\n' +
            '                </div>\n' +
            '                <div>\n' +
            '                    <label></label>\n' +
            '                    <input class="channelInput" placeholder="您是怎么知道我们的"/>\n' +
            '                </div>\n' +
            '                <div>\n' +
            '                    <button class="summit summitBtn">提交</button>\n' +
            '                </div>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '\n' +
            '    </div>\n' +
            '</div>'
        $('body').append(mFormHtml)
        $('.dialog-title .close,.cancel').click(function () {
            $('.container-mobile,.container-pc').remove()
            $('.applyBtn-web').removeClass('disable')
            $('.applyBtn button').removeClass('disable')
        })
    },

    removeMobileForm () {
        $('.container-mobile.form').remove()
    },

    showMobileFinished () {
        let mFinishedHtml = '<div class="container-mobile finished">\n' +
            '    <div class="dialog">\n' +
            '        <div class="dialog-content-wrapper">\n' +
            '            <div class="dialog-title">\n' +
            '                <span class="close"></span>\n' +
            '            </div>\n' +
            '            <div class="dialog-content-finish">\n' +
            '                <div class="holder"></div>\n' +
            '                <div class="dialog-finish-web"></div>\n' +
            '                <!--<img height="160px" src="../../assets/img/magic2/dialog-web-finish.svg">-->\n' +
            '                <h2>已提交申请</h2>\n' +
            '                <div class="info">将会有运营人员在1-2个工作日内联系您，为您开通使用</div>\n' +
            '                <button class="summit">知道了</button>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '\n' +
            '    </div>\n' +
            '</div>'
        $('body').append(mFinishedHtml)
        $('.dialog-title .close,.cancel').click(function () {
            $('.container-mobile,.container-pc').remove()
            $('.applyBtn-web').removeClass('disable')
            $('.applyBtn button').removeClass('disable')

        })
        $('.dialog-content-finish .summit').click(function () {
            // $('.container-mobile.finished').css({ "display": 'none' })
            $('.container-mobile.finished').remove()
        })
    },

    removeMobileFinished () {
        $('.container-mobile.finished').remove()
    },

}



// WEBPACK FOOTER //
// ./src/pages/index/layer.js